import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=6a583ae4&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Payment.vue?vue&type=style&index=0&id=6a583ae4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Payment.vue?vue&type=style&index=1&id=6a583ae4&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6a583ae4",
  "380ec120"
  
)

export default component.exports